@if (!useSummaryView) {
  @if (!field.hidden) {
    <div animate.enter="fade-in">
      <div class="flex flex-row items-center ml-4 grid grid-cols-6 gap-4">
        <div class="leading-6 font-large text-lg col-start-1 col-span-2">{{ field.label | localize }}</div>
        <div class="leading-6 col-start-3 col-span-2">
          <mat-checkbox [(ngModel)]="repeatRows" color="primary">
            {{ 'allowRepeatedRows' | transloco }}
          </mat-checkbox>
        </div>
        <div class="col-start-6 col-span-1">
          @if (!editView) {
            <button mat-flat-button class="ml-300 mr-2 mb-3" color="primary" (click)="editView = !editView">
              <span >{{ "editView" | transloco }}</span>
            </button>
          }
          @if (editView) {
            <button mat-flat-button class="ml-300 mr-2 mb-3" color="primary" (click)="createTableView()">
              <span>{{ "viewDataTable" | transloco }}</span>
            </button>
          }
        </div>
      </div>
      @if (editView) {
        <div class="flex flex-col justify-between mb-2 mt-4 px-2">
          <div class="flex flex-col flex-auto mb-2 px-2">
            <mat-accordion class="w-full">
              @for (embeddedForm of field.embeddedForms; track embeddedForm; let i = $index) {
                <div class="flex flex-row w-full">
                  <mat-expansion-panel class="mb-1 w-full" [expanded]="panel === i" (opened)="setPanel(i)"
                    (closed)="closePanel(i)" hideToggle="true">
                    <mat-expansion-panel-header>
                      <mat-panel-title>
                        <span class="font-bold font-large text-lg mx-2">{{ chooseOption(embeddedForm) }}
                        </span>
                      </mat-panel-title>
                      <mat-panel-description class="justify-end">
                        @if (panel === i) {
                          <mat-icon>remove</mat-icon>
                        }
                        @if (panel !== i || (panels && panel === panels['_results'].length - 1 && panel > 0 && panel !== i)) {
                          <mat-icon>add</mat-icon>
                        }
                      </mat-panel-description>
                    </mat-expansion-panel-header>
                    @if (field) {
                      <dtype-component-list class="w-full" [dtypeForm]="embeddedForm"
                        [isUpdate]="isUpdate">
                      </dtype-component-list>
                    }
                    <div class="flex flex-row justify-end w-full">
                      <button mat-flat-button class="mt-2 mr-3" color="accent" (click)="addItem()"
                        [disabled]="field.readonly || field.control.disabled">
                        <mat-icon class="icon-size-5 mr-2 text-on-accent" svgIcon="mat_outline:add"></mat-icon>
                        {{ "addRow" | transloco }}
                      </button>
                      <button mat-flat-button class="mt-2 mr-3" color="primary"
                        (click)="saveItem(embeddedForm, i)"
                        [disabled]="field.readonly || field.control.disabled">
                        {{ "saveRow" | transloco }}
                      </button>
                      @if (panels && panels['_results'].length > 1) {
                        <button mat-flat-button class="mt-2 mr-1" color="warn" (click)="removeItem(i)"
                          [disabled]="field.readonly || field.control.disabled">
                          {{ "removeRow" | transloco }}
                        </button>
                      }
                    </div>
                  </mat-expansion-panel>
                </div>
              }
              <div>
                <button mat-flat-button class="m-3" color="accent" (click)="addItem()"
                  [disabled]="field.readonly || field.control.disabled">
                  <mat-icon class="icon-size-5 mr-2 text-on-accent" svgIcon="mat_outline:add"></mat-icon>
                  {{ "addRow" | transloco }}
                </button>
              </div>
            </mat-accordion>
            @if (field.hint) {
              <div class="text-md text-secondary">{{ field.hint | localize }}</div>
            }
            @if (!field.readonly &&
              field.control.touched &&
              field.control.errors) {
              @if (field.control.hasError('required')) {
                <div class="text-sm text-warn leading-none font-medium">
                  {{ 'errorRequiredField' | transloco }}
                </div>
              }
              @if (field.control.hasError('minlength')) {
                <div class="text-sm text-warn leading-none font-medium">
                  {{ 'errorMinLengthField' | transloco:{ requiredLength: field.control.errors.minlength.requiredLength
                  } }}
                </div>
              }
              @if (field.control.hasError('maxlength')) {
                <div class="text-sm text-warn leading-none font-medium">
                  {{ 'errorMaxLengthField' | transloco:{ requiredLength: field.control.errors.maxlength.requiredLength
                  } }}
                </div>
              }
            }
          </div>
        </div>
      }
      @if (!editView) {
        <div class="flex flex-col justify-between mb-2 mt-4 px-2">
          <!-- Header -->
            <div class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] z-10 text-sm sticky top-0 grid gap-4 py-4 px-4 sm:px-6 shadow text-md font-semibold text-secondary
                        bg-gray-50 dark:bg-slate-900">
            @for (tag of tableHeader; track tag) {
              <div class="flex items-center">
                {{ tag | localize }}
              </div>
            }
          </div>
          <!-- Rows -->
          @for (row of tableData; track row; let i = $index) {
            <div class="grid grid-flow-col auto-cols-[minmax(0,_2fr)] items-center gap-4 py-3 px-4 sm:px-6 border-b">
              @for (value of row; track value) {
                <div class="flex items-center">
                  {{value}}
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }
}